import React from 'react';
import { HStack, Text } from '@chakra-ui/react';

export default function SidePanelHeading({ icon, children }) {
  return <HStack spacing={2} align="center" minW={0}>
    <span aria-hidden="true" className="material-icons-outlined" style={{ fontSize: '18px', color: '#718096', flexShrink: 0 }}>{icon}</span>
    <Text fontSize="md" fontWeight="700" color="gray.800">{children}</Text>
  </HStack>;
}
